import {useEffect, useState} from "react";
import {toast} from "react-hot-toast";
import {AccountService} from "./Service";
import Select from "react-select";
import {CustomerService} from "../customer/Service";

const AddVoucher = () => {
    const [type, setType] = useState<string|null>(null);
    const service = new AccountService();
    const customerService = new CustomerService();
    const [voucherNumber, setVoucherNumber] = useState("");
    const [name, setName] = useState("");
    const [customerType, setCustomerType] = useState<{
        label: string;
        value: string;
    } | null>(null);
    const [paymentMode, setPaymentMode] = useState<{
        label: string;
        value: string;
    } | null>(null);
    const [paidAmount, setPaidAmount] = useState(0);
    const [dueAmount, setDueAmount] = useState(0);
    const [notes, setNotes] = useState("");
    const [comments, setComments] = useState("");
    const [date, setDate] = useState('');
    const [customerOptions, setCustomerOptions] = useState<
        { label: string; value: string }[]
    >([]);
    const [customer, setCustomer] = useState<
        { label: string; value: string } | null
    >(null);

    const [customerTypeOptions, setCustomerTypeOptions] = useState<
        { label: string; value: string }[]
    >([
        {label: "Customer", value: "Customer"},
        {label: "Vendor", value: "Vendor"},
        {label: "Staff", value: "Staff"},
    ]);
    const [paymentModeOptions, setPaymentModeOptions] = useState<
        { label: string; value: string }[]
    >([
        {label: "Cash", value: "Cash"},
        {label: "Bank", value: "Bank"},
    ]);

    const handleSubmit = async (e: any) => {
        e.preventDefault();
        if (name === "") {
            toast.error("Please fill all the required fields");
            return;
        }
        toast.loading("Adding voucher...");
        const data = {
            number: voucherNumber,
            name,
            customerType: customerType?.value,
            paymentMode: paymentMode?.value,
            paidAmount,
            dueAmount,
            type,
            notes,
            date,
            ...(customer && {customer: customer.value}),
            ...(comments && {comments}),
        };
        const res = await service.addVoucher(data);
        if (res) {
            toast.success("Voucher added successfully");
            setVoucherNumber("");
            setName("");
            setCustomerType(null);
            setPaymentMode(null);
            setPaidAmount(0);
            setDueAmount(0);
            setNotes("");
            await fetchVoucherNumber();
        }
    };

    useEffect(() => {
        if (window.location.pathname.includes("receipt")) {
            setType("Receipt");
        } else if (window.location.pathname.includes("payment")) {
            setType("Payment");
        }
    }, [window.location.pathname]);

    useEffect(() => {
        setDate(new Date().toISOString().split('T')[0]);
    }, []);

    useEffect(() => {
        const fetchCustomers = async () => {
            const res = await customerService.all();
            if (res) {
                const options = res.filter(
                    (item: any) => item.type === customerType?.value
                ).map((item: any) => {
                    return {
                        label: item.name,
                        value: item.id,
                    };
                });
                setCustomerOptions(options);
            }
        };
        if (customerType !== null && customerType.value === "Customer") {
            fetchCustomers();
        }
    }, [customerType]);

    useEffect(() => {
        setName(customer?.label || "");
    }, [customer]);

    const fetchVoucherNumber = async () => {
        const res = await service.getVoucherNumber(type!);
        if (res) {
            setVoucherNumber(res);
        }
    };

    useEffect(() => {
        if (type) {
            fetchVoucherNumber();
        }
    }, [type]);

    return (
        <>
            <div className="card mb-0">
                <div className="card-body">
                    <div className="page-header">
                        <div className="content-page-header">
                            <h5>Add Voucher</h5>
                        </div>
                    </div>
                    <form onSubmit={handleSubmit} className="row">
                        <div className="col-lg-4 col-md-6 col-sm-12">
                            <div className="input-block mb-3">
                                <label>
                                    {type === "Payment" ? "Voucher" : "Receipt"} Number{" "}
                                    <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder={`Enter ${
                                        type === "Payment" ? "Voucher" : "Receipt"
                                    } Number`}
                                    value={voucherNumber}
                                    onChange={(e) => setVoucherNumber(e.target.value)}
                                    required={true}
                                />
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12">
                            <div className="input-block mb-3">
                                <label>
                                    Date <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="date"
                                    className="form-control"
                                    placeholder="Enter date"
                                    value={date}
                                    onChange={(e) => setDate(e.target.value)}
                                    required={true}
                                />
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12">
                            <div className="input-block mb-3">
                                <label>
                                    Type <span className="text-danger">*</span>
                                </label>
                                <Select
                                    name="receipt-type"
                                    options={customerTypeOptions}
                                    value={customerType}
                                    onChange={setCustomerType}
                                    required={true}
                                />
                            </div>
                        </div>

                        {customerType?.value === "Customer" && <div className="col-lg-4 col-md-6 col-sm-12">
                            <div className="input-block mb-3">
                                <label>
                                    Customer <span className="text-danger">*</span>
                                </label>
                                <Select
                                    name="receipt-type"
                                    options={customerOptions}
                                    value={customer}
                                    onChange={setCustomer}
                                    required={true}
                                />
                            </div>
                        </div>}
                        <div className="col-lg-4 col-md-6 col-sm-12">
                            <div className="input-block mb-3">
                                <label>
                                    Name <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Name"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    required={true}
                                />
                            </div>
                        </div>
                        {(customerType?.value === "Customer" ||
                            customerType?.value === "Vendor" || customerType?.value === "Staff") && (
                            <>
                                <div className="col-lg-4 col-md-6 col-sm-12">
                                    <div className="input-block mb-3">
                                        <label>
                                            Payment Mode
                                        </label>
                                        <Select
                                            name="payment-mode"
                                            options={paymentModeOptions}
                                            value={paymentMode}
                                            onChange={setPaymentMode}
                                            required={false}
                                        />
                                    </div>
                                </div>
                                {
                                    paymentMode?.value === "Bank" && <div className="col-lg-4 col-md-6 col-sm-12">
                                        <div className="input-block mb-3">
                                            <label>
                                                Comments
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter transaction id"
                                                value={comments}
                                                onChange={(e) => setComments(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                }
                                <div className="col-lg-4 col-md-6 col-sm-12">
                                    <div className="input-block mb-3">
                                        <label>Paid Amount</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            placeholder="Enter Paid Amount"
                                            value={paidAmount}
                                            onChange={(e) =>
                                                setPaidAmount(parseFloat(e.target.value))
                                            }
                                            required={false}
                                        />
                                    </div>
                                </div>
                                {customerType?.value === "Customer" && (
                                    <>
                                        <div className="col-lg-4 col-md-6 col-sm-12">
                                            <div className="input-block mb-3">
                                                <label>Due Amount</label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    placeholder="Enter Due Amount"
                                                    value={dueAmount}
                                                    onChange={(e) =>
                                                        setDueAmount(parseFloat(e.target.value))
                                                    }
                                                    required={false}
                                                />
                                            </div>
                                        </div>
                                    </>
                                )}
                                <div className="col-12">
                                    <div className="input-block mb-3">
                                        <label>Notes</label>
                                        <textarea
                                            className="form-control"
                                            placeholder="Enter notes"
                                            value={notes}
                                            onChange={(e) => setNotes(e.target.value)}
                                            required={false}
                                        />
                                    </div>
                                </div>
                            </>
                        )}

                        <div className="col-12">
                            <div className="btn-path text-end">
                                <a
                                    href="javascript:void(0);"
                                    className="btn btn-cancel bg-primary-light me-3"
                                    onClick={() => {
                                        window.history.back();
                                    }}
                                >
                                    Cancel
                                </a>
                                <button type="submit" className="btn btn-primary">
                                    Save Changes
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
};

export default AddVoucher;
